import React from 'react'
import { useDispatch } from 'react-redux'
import { setUserData } from '../../redux/reducer/appReducer'
import UserRegistrationModal from '../Register/UserRegistrationModal'



function EditProfileModal(props) {
    const { selectedModal, setSelectedModal } = props

    const dispatch = useDispatch()

    const onSubmit = (data) => {

        if (data?.formData?.userId) {
            let userData = JSON.parse(localStorage.getItem("userData"))
            if (userData?.userId === data?.formData?.userId) {
                let newData = {
                    ...data?.formData,
                    password: ""
                }

                dispatch(setUserData(newData))
                localStorage.setItem("userData", JSON.stringify(newData))
            }
        }
        onClose()
    }

    const onClose = () => {
        setSelectedModal("")
    }

    let userData = JSON.parse(localStorage.getItem("userData"))
    const data = {
        ...props,
        title: "Edit Profile",
        isEditing: true,
        show: true, onSubmit, onClose: onClose,
        formData: userData
    }

    return <UserRegistrationModal {...data} />


}

export default EditProfileModal